import { Search } from "lucide-react";

import { Input } from "@/components/ui/input";
import { categoryLabels, pickText } from "@/lib/content";

const categories = ["all", "sefira", "chakra", "tattva", "symbol", "structure"];

export const ArchiveFilters = ({ language, query, onQueryChange, category, onCategoryChange }) => {
  return (
    <div className="glass-card rounded-[2rem] p-5 md:p-6" data-testid="archive-filters-panel">
      <div className="flex items-center gap-3 text-primary" data-testid="archive-filters-header">
        <Search className="h-4 w-4" />
        <p className="section-label">{pickText(language, "Search the archive", "Cerca nell'archivio")}</p>
      </div>
      <div className="mt-4 space-y-4">
        <Input
          className="h-12 rounded-full border-white/10 bg-black/20 px-5 text-white"
          data-testid="archive-search-input"
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder={pickText(language, "Search by title, region, or correspondence", "Cerca per titolo, regione o corrispondenza")}
          value={query}
        />
        <div className="flex flex-wrap gap-2" data-testid="archive-category-buttons">
          {categories.map((item) => {
            const active = item === category;
            return (
              <button
                key={item}
                className={`rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] transition-colors duration-300 ${
                  active
                    ? "border-primary/40 bg-primary/10 text-primary"
                    : "border-white/10 text-slate-300 hover:border-primary/30 hover:text-primary"
                }`}
                data-testid={`archive-category-button-${item}`}
                onClick={() => onCategoryChange(item)}
                type="button"
              >
                {categoryLabels[language][item]}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};